const buildUrl = (baseUrl, searchParameters, hash) => {
  let url = baseUrl;
  if (searchParameters) {
    const queryParts = Object.entries(searchParameters).map(([key, value]) => (
      value && `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    ));
    url = `${url}?${queryParts.filter(Boolean).join('&')}`;
  }
  if (hash) {
    url += `#${hash}`;
  }

  return url;
};

export default buildUrl;



// WEBPACK FOOTER //
// ./app/utils/buildUrl.js